import { HeroLayout, Image, Text } from '@change/ds-core-ui';

import { useStarterQuoteContainer } from './hooks/useStarterQuoteContainer';

export const StarterQuoteContainer: React.FC = () => {
	const {
		data: { starterQuote, quoteImage, byLine },
	} = useStarterQuoteContainer();

	return (
		<HeroLayout
			media={
				<Image
					src={quoteImage}
					alt="petition image next to starter quote"
					className="h-full w-full object-cover object-top"
				/>
			}
			reverseMd
			variant="1/2"
		>
			<div className="bg-background-raised flex h-full flex-col justify-center gap-2 p-6 md:p-12">
				{/* TODO replace with proper font when available */}
				<Text as="p" variant="heading" size="small" fontWeight="light" className="italic">
					“{starterQuote}”
				</Text>
				<Text fontWeight="bold">{byLine}</Text>
			</div>
		</HeroLayout>
	);
};
